// Framework + libraries
import { signalStore, withState } from '@ngrx/signals';
import { withDevtools, withStorageSync } from '@angular-architects/ngrx-toolkit';
// Ours
import { IamDivision } from '@r1-compass-library/models/iam/iam-division.model';
import { DivisionConfig } from '@r1-compass-library/models';
import { withSyncedGlobalDivisionMethods } from '@r1-compass-library/store/divisions/withSyncedGlobalDivisionMethods';

export interface GlobalDivisionStoreState {
    allIamDivisions: IamDivision[];
    allDivisionConfigs: DivisionConfig[];
}

export const initialState: GlobalDivisionStoreState = {
    allDivisionConfigs: [],
    allIamDivisions: [],
};
export const GlobalDivisionsStore = signalStore(
    { providedIn: 'root' },
    withDevtools('globalDivisions'),
    withState<GlobalDivisionStoreState>(initialState),
    withSyncedGlobalDivisionMethods(initialState), // The state is passed directly to these, they could be inline in the store as well
    withStorageSync({ key: 'globalDivisions', storage: () => localStorage })
);

export type GlobalDivisionsStore = InstanceType<typeof GlobalDivisionsStore>;
